import { useSelector } from 'react-redux'
import { PhoneField } from '@calendly/form/raw'

import { countryCodeSelector } from 'selectors'
import { getDialCodeForCountry } from 'services/phone_number'

export default (props) => {
  const countryCode = useSelector(countryCodeSelector)
  // Match routing form: when empty, show dial code for user's country so they don't have to type it
  const defaultDialCode = getDialCodeForCountry(countryCode)
  let number
  if (!props.number && defaultDialCode) {
    number = defaultDialCode
  } else {
    number = props.number || ''
  }

  return (
    <PhoneField {...props} countryCode={countryCode} number={number} />
  )
}
